"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";

/**
 * Обёртка, которая скрывает свой children на miniapp-роутах (/tg/app/*, /max/app/*).
 * Используется в layout.tsx для Header и Footer — миниапп должен выглядеть
 * нативно, без шапки сайта и футера.
 */
export function SiteChrome({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (pathname.startsWith("/tg/app") || pathname.startsWith("/max/app")) {
    return null;
  }
  return <>{children}</>;
}
